<template>
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16 0H2C0.9 0 0 0.9 0 2V16C0 17.1 0.9 18 2 18H16C17.1 18 18 17.1 18 16V2C18 0.9 17.1 0 16 0ZM12 8C12 9.11 11.1 10 10 10H8V12H12V14H6V10C6 8.89 6.9 8 8 8H10V6H6V4H10C11.1 4 12 4.89 12 6V8Z"
      fill="#F2994A"
    />
  </svg>
</template>
